import { useEffect } from "react";

const usePageShowHandler = (setLoading) => {
  useEffect(() => {

    const handler = (event) => {
      if (event.persisted) {
       if(setLoading) {
          setLoading(false);
        }
      }
    };

    window.addEventListener("pageshow", handler);
  }, []);
};

export { usePageShowHandler };